/* eslint-disable */
// 获取随机整数
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * @description 获取参数数据类型
 * @param {*} obj 
 * @returns {string} 返回数据类型字符串，小写
 */
export const getDataType = (obj) => {
  let res = Object.prototype.toString.call(obj).split(' ')[1]
  res = res.substring(0, res.length - 1).toLowerCase()
  return res
}

// 数组洗牌
export function shuffle(arr) {
  const _arr = arr.slice();
  for (let i = 0; i < _arr.length; i++) {
    const j = getRandomInt(0, i);
    const t = _arr[i];
    _arr[i] = _arr[j];
    _arr[j] = t;
  }
  return _arr;
}

// 节流函数
export function debounce(func, delay) {
  let timer;

  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function isIos() {
  const clientTexts = ['iPhone', 'iPad'];
  for (let i = 0; i < clientTexts.length; i++) {
    if (navigator.userAgent.indexOf(clientTexts[i]) > -1) {
      return true;
    }
  }
  return false;
}

export function isAndroid() {
  return navigator.userAgent.indexOf('Android') > -1;
}

export function isMobile() {
  const clientTexts = ['iPhone', 'iPad', 'Android', 'Mobile'];
  for (let i = 0; i < clientTexts.length; i++) {
    if (navigator.userAgent.indexOf(clientTexts[i]) > -1) {
      return true;
    }
  }
  return false;
}

export function isPC() {
  return !isMobile();
}

export function isWechat() {
  return navigator.userAgent.indexOf('MicroMessenger') > -1;
}

export function isWeibo() {
  return navigator.userAgent.toLowerCase().indexOf(' weibo') > -1;
}

export function isQQ() {
  return navigator.userAgent.toLowerCase().indexOf(' qq/') > -1;
}


// 有讲app
export function isYoJiangApp() {
  return navigator.userAgent.indexOf(' YoJiang') > -1 || navigator.userAgent.indexOf(
    ' native-code') > -1;
}

// 获取有讲APP的登录信息
export const getYoJiangAppLoginInfo = () => {
  if (isYoJiangApp()) {
    let loginInfo;
    if (isAndroid()) {
      loginInfo = window.android.YoJiangLoginInfo();
      try {
        return JSON.parse(loginInfo);
      } catch (err) {
        console.log(err);

        const data = JSON.stringify({
          event: "login"
        });
        // eslint-disable-next-line
        window.android.postData(data)
      }
    } else if (isIos()) {
      // eslint-disable-next-line
      loginInfo = YoJiangLoginInfo();
      if (loginInfo) {
        return loginInfo;
      } else {
        const data = JSON.stringify({
          event: "login"
        });

        // eslint-disable-next-line
        window.webkit.messageHandlers.YouJangAppAction.postMessage(data)
      }
    }
  }
};

/**
 * 字符串后四位转化为万
 * @param {String} num
 * @return {String}
 */
export const handleCount = (num) => {
  if (isNaN(Number(num))) {
    return 0;
  }
  if (num > 1e4) {
    const ret = Number((num / 1e4).toFixed(1));
    return `${ret}万`;
  }
  if (num < 0) {
    return 0;
  }
  return num;
};

export const decodeBase64 = (s) => {
  const e = {};
  let i;
  let b = 0;
  let c;
  let x;
  let l = 0;
  let a;
  let r = '';
  const w = String.fromCharCode;
  const L = s.length;
  const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (i = 0; i < 64; i++) {
    e[A.charAt(i)] = i;
  }
  for (x = 0; x < L; x++) {
    c = e[s.charAt(x)];
    b = (b << 6) + c;
    l += 6;
    while (l >= 8) {
      ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a));
    }
  }
  return r;
};

export const checkPhone = (phone) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
    return false;
  }
  return true;
};

// 压缩图片路径
export const resizeUrl = (url, width) => {
  // console.log("resizeUrl: ", url, width);
  if (url && width) {
    // 七牛
    if (url.includes(QINIU_DOMAIN_URL)) {
      return resizeQiniuUrl(url, width)
    }
    if (url.includes(ALCDN_DOMAIN_URL)) {
      return resizeAlcdnUrl(url, width)
    }
  }
  return url
}

// 七牛链接压缩
export const resizeQiniuUrl = (url, width) => {
  if (url.indexOf('?') > 0) {
    url = url.substr(0, url.indexOf('?'))
  }
  const isWebp = url.toLowerCase().indexOf('.webp') > 0
  if (width) {
    url = url + '?imageView2/2/w/' + Math.floor(width * 2)
  }
  if (isWebp) {
    if (url.indexOf('?imageView2') > 0) url = url + '/format/jpg'
    else url = url + '?imageView2/2/format/jpg'
  }
  // console.log('resizeQiniuUrl', width, url)
  return url
}

/**
 * @description 阿里云对象存储图片链接压缩
 * @param {string} url 图片链接
 * @param {number} width 图片宽度
 * @returns {string} 返回新的图片地址
 */
export const resizeAlcdnUrl = (url, width) => {
  if (url.indexOf('?') > 0) {
    url = url.substr(0, url.indexOf('?'))
  }

  if (width) {
    return url + '?x-oss-process=image/resize,w_' + Math.floor(width * 2)
  }

  return url
}

export function urlParam(name, url = window.location.href) {
  // if (!url) {
  //   url = window.location.href
  // }
  const regx = new RegExp("[?&]" + name + "=([^&#]*)");
  const results = regx.exec(url);
  // if (!results && data && data.uri) {
  //     results = regx.exec(data.uri);
  // }
  if (results) {
    return decodeURIComponent(results[1]);
  } else {
    return "";
  }
}

export function addParam(url, name, value) {
  if (url.indexOf("?" + name + "=") > 0 || url.indexOf("&" + name + "=") > 0) {
    url = deleteParam(url, name);
  }
  return (
    url +
    (url.indexOf("?") < 0 ? "?" : "&") +
    name +
    "=" +
    encodeURIComponent(value)
  );
}

export function deleteParam(url, name) {
  const urlList = url.split("?");
  if (urlList.length <= 1) {
    return url;
  }
  const argsList = urlList[1].split("&");
  url = urlList[0];
  for (let i = 0; i < argsList.length; i++) {
    if (argsList[i].indexOf(name + "=") >= 0) {
      continue;
    }
    url = url + (url.indexOf("?") < 0 ? "?" : "&");
    url = url + argsList[i];
  }
  return url;
}

/**
 * @description 格式化日期
 * @param {string|number|Date} [date] 可以转换为Date对象的字符串或毫秒数或date对象，不传默认当前时间
 * @param {Boolean} isShowWeek 是否需要显示周几，默认显示
 * @returns {string|boolean} 成功返回示例‘6月3日（周四）’，错误返回false
 */
export const formatDate = (date, isShowWeek = true) => {
  let myDate = getDataType(date) === 'date' ? date : new Date();

  if (date !== undefined) {
    date = new Date(date);

    // 判断用户传的参数是否可以正确的转换为Date对象
    if (isNaN(date)) {
      console.error('formatDate(): arguments error.');
    } else {
      myDate = date;
    }
  }

  const month = myDate.getMonth() + 1;
  const day = myDate.getDate();

  if (isShowWeek) {
    const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

    return `${month}月${day}日（${weeks[myDate.getDay()]}）`;
  }

  return `${month}月${day}日`;
}

/**
 * @description 日期校验函数
 * @param {string} date 日期字符串
 * @returns 正确的日期返回true，反之false
 */
export const verifyDate = (date) => {
  if (typeof date !== 'string') {
    return false;
  }

  // 先校验日期字符串的格式
  const regExp = /^\d{4}[-./]((0?[0-9])|(1[012]))[-./](([1-9])|([012][0-9])|(3[01]))$/;

  if (!regExp.test(date)) {
    return false;
  }

  const dates = date.match(/\d+/g);

  // dates[0] | 0 隐式转换数据类型，例如：099 | 0 => 99
  const year = dates[0] | 0;
  const month = dates[1] | 0;
  const day = dates[2] | 0;

  // 平年天数不能大于28，闰年不能大于29
  if (month === 2) {
    if (day > 29) {
      return false;
    } else if (day === 29) {
      if (!(year % 4 === 0 && year % 100 !== 0) && !(year % 400 === 0)) {
        return false;
      }
    }
  }

  // 这些月份天数不能大于30
  if (day > 30 && [4, 6, 9, 11].indexOf(month) !== -1) {
    return false;
  }

  return true;
}

/**
 * @description 复制内容到剪贴板
 * @param {string} text 要复制的文本
 */
export const clipboard = (text) => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);

  /**
   * 检查是否之前曾选中过内容
   * 如果找到，则保存选中
   * 没有标记为false
   */
  const selected =
    document.getSelection().rangeCount > 0 ?
    document.getSelection().getRangeAt(0) :
    false;

  el.select();
  // 复制 - 仅当作为用户操作的响应结果时才可以工作(比如，点击事件)
  document.execCommand('copy');
  document.body.removeChild(el);

  // 如果在复制前已存在选中的内容
  if (selected) {
    // 取消 HTML 文档中所有的选中部分，恢复原来的选中
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

/**
 * @description 获取当前日期的字符串格式，例如：2021-01-01
 * @param {string} separator 分割符，默认 ‘-’
 * @param {Date} dateObj date对象，默认当前时间
 */
export const getCurrdateStr = (separator = '-', dateObj = null) => {
  if (!dateObj || getDataType(dateObj) !== 'date') {
    dateObj = new Date();
  }

  const year = dateObj.getFullYear();

  let month = dateObj.getMonth() + 1;
  month = month > 9 ? month : `0${month}`;

  let day = dateObj.getDate();
  day = day > 9 ? day : `0${day}`;

  return `${year}${separator}${month}${separator}${day}`;
};

/**
 * @description 获取时间问候语，例如：上午好
 * @param {number} hour 小时
 * @returns {string} 返回问候语
 */
export const getTimeGreeting = hour => {
  if(typeof hour !== 'number' || hour < 0 || hour > 24) {
    return '您好'
  }

  hour = Math.trunc(hour);

  const weeHoursText = '凌晨好';
  const matinalText = '早上好';
  const amText = '上午好';
  const noonText = '中午好';
  const pmText = '下午好';
  const nightText = '晚上好';

  const timeGteetingObj = {
    0: weeHoursText,
    1: weeHoursText,
    2: weeHoursText,
    3: weeHoursText,
    4: weeHoursText,
    5: weeHoursText,
    6: matinalText,
    7: matinalText,
    8: amText,
    9: amText,
    10: amText,
    11: amText,
    12: noonText,
    13: noonText,
    14: pmText,
    15: pmText,
    16: pmText,
    17: pmText,
    18: nightText,
    19: nightText,
    20: nightText,
    21: nightText,
    22: nightText,
    23: nightText,
    24: nightText
  }

  return timeGteetingObj[hour];
};
